import type { ComponentProps } from "react";
import * as ContextMenu from "zeego/context-menu";
import { useTheme } from "~/providers/ThemeProvider";

type ItemTitleProps = {
    selected?: boolean;
} & ComponentProps<typeof ContextMenu.ItemTitle>;

export const MenuItemTitle = ContextMenu.create(({ selected, ...props }: ItemTitleProps) => {
    const { text } = useTheme();

    return <ContextMenu.ItemTitle {...props} style={selected ? text.selected : text.primary} />;
}, "ItemTitle");
